import { Routes } from '@angular/router';
import { AuthenticationGuard } from './authentication.guard';
import { UserAuthority } from './domain/model/user-authority';
import { DealerLoginFormComponent } from './feature/dealer/authentication/dealer-login-form.component';
import { DealerPanelComponent } from './feature/dealer/panel/dealer-panel.component';
import { DealerProfileResolver } from './feature/dealer/profile/dealer-profile-resolver';
import { DealerProfileComponent } from './feature/dealer/profile/dealer-profile.component';
import { DealerQueryReportsComponent } from './feature/dealer/query-reports/dealer-query-reports.component';
import { DealerReportLogComponent } from './feature/dealer/report/dealer-report-log.component';
import { DealerReportSearchComponent } from './feature/dealer/report-search/dealer-report-search.component';
import { LogoutComponent } from './logout/logout.component';
import { AdminLoginFormComponent } from '@app/feature/admin/authentication/admin-login-form.component';
import { AdminSearchComponent } from '@app/feature/admin/search/admin-search.component';
import { AdminMainComponent } from '@app/feature/admin/main/admin-main.component';
import { AdminDealerInfoComponent } from '@app/feature/admin/dealer-info/admin-dealer-info.component';
import { AdminDealerReportLogComponent } from '@app/feature/admin/dealer-info/dealer-report-log/admin-dealer-report-log.component';
import { AdminDealerProfileComponent } from '@app/feature/admin/dealer-info/dealer-profile/admin-dealer-profile.component';
import { AdminDealerQueryReportsComponent } from '@app/feature/admin/dealer-info/dealer-query-reports/admin-dealer-query-reports.component';
import { AdminDealerReportSearchComponent } from '@app/feature/admin/dealer-info/dealer-report-search/admin-dealer-report-search.component';
import { DisclaimerComponent } from '@app/feature/disclaimer/disclaimer/disclaimer.component';
import { BulkUploadComponent } from "@app/feature/admin/report/upload/bulkupload.component";
var ɵ0 = {
    authorities: [
        UserAuthority.MY_INFO
    ],
    redirectTo: ['/login']
}, ɵ1 = {
    authorities: [
        UserAuthority.DEALER_INFO
    ],
    redirectTo: ['/admin-login']
}, ɵ2 = {
    authorities: [
        UserAuthority.DEALER_INFO
    ],
    redirectTo: ['/admin-login']
}, ɵ3 = {
    authorities: [
        UserAuthority.MANAGE_BULK_IMPORT
    ],
    redirectTo: ['/admin-login']
}, ɵ4 = {
    authorities: [
        UserAuthority.DEALER_INFO
    ],
    redirectTo: ['/admin-login']
};
var routes = [
    // Application entry
    {
        path: '', redirectTo: 'dealer', pathMatch: 'full'
    },
    /**
     * Dealer related functionality
     */
    {
        path: 'dealer',
        component: DealerPanelComponent,
        canActivate: [AuthenticationGuard],
        data: ɵ0,
        resolve: {
            profile: DealerProfileResolver
        },
        children: [
            // Dealer entry point - redirect to Report Log by default.
            { path: '', redirectTo: 'report-log', pathMatch: 'full' },
            // Dealer - Report Log
            { path: 'report-log',
                component: DealerReportLogComponent,
                canActivate: [AuthenticationGuard],
                resolve: {
                    profile: DealerProfileResolver
                }
            },
            // Dealer - Report Search
            { path: 'report-search',
                component: DealerReportSearchComponent,
                canActivate: [AuthenticationGuard],
                resolve: {
                    profile: DealerProfileResolver
                }
            },
            // Dealer - My Profile
            {
                path: 'my-profile',
                component: DealerProfileComponent,
                canActivate: [AuthenticationGuard],
                resolve: {
                    profile: DealerProfileResolver
                }
            },
            // Dealer - Query Reports
            { path: 'query-reports',
                component: DealerQueryReportsComponent,
                canActivate: [AuthenticationGuard],
                resolve: {
                    profile: DealerProfileResolver
                }
            }
        ]
    },
    /**
     *  Admin related functionality
     */
    {
        path: 'admin',
        component: AdminMainComponent,
        canActivate: [AuthenticationGuard],
        data: ɵ1,
        children: [
            // Admin entry point - redirect to Search by default.
            { path: '', redirectTo: 'search', pathMatch: 'full' },
            // Admin - Dealer Search
            {
                path: 'search',
                component: AdminSearchComponent,
                canActivate: [AuthenticationGuard],
                data: ɵ2,
            },
            // Admin - Bulk Purchase Upload
            {
                path: 'report-upload',
                component: BulkUploadComponent,
                canActivate: [AuthenticationGuard],
                data: ɵ3,
            },
            // Admin - Dealer Information
            {
                path: 'dealer/:dealerId',
                component: AdminDealerInfoComponent,
                canActivate: [AuthenticationGuard],
                data: ɵ4,
                children: [
                    // Admin - Dealer entry point - redirect to Admin - Dealer Profile by default.
                    { path: '', redirectTo: 'report-log', pathMatch: 'full' },
                    // Admin - Dealer Report Log
                    { path: 'report-search',
                        component: AdminDealerReportSearchComponent,
                        canActivate: [AuthenticationGuard] },
                    // Admin - Dealer Report Log
                    { path: 'report-log',
                        component: AdminDealerReportLogComponent,
                        canActivate: [AuthenticationGuard] },
                    // Admin - Dealer Query Reports
                    { path: 'query-reports',
                        component: AdminDealerQueryReportsComponent,
                        canActivate: [AuthenticationGuard] },
                    // Admin - Dealer Profile
                    {
                        path: 'profile',
                        component: AdminDealerProfileComponent,
                        canActivate: [AuthenticationGuard]
                    }
                ],
                resolve: {
                    profile: DealerProfileResolver
                }
            }
        ]
    },
    {
        path: 'disclaimer', component: DisclaimerComponent
    },
    {
        path: 'login', component: DealerLoginFormComponent
    },
    {
        path: 'logout', component: LogoutComponent
    },
    {
        path: 'admin-login', component: AdminLoginFormComponent
    }
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
